import { Navigate, Route, Routes } from "react-router-dom";
import { routeConstants } from "navigation/routeConstants";

import ExternalIncomingPage from "pages/ExternalIncomingPage/ExternalIncomingPage";
import ExternalSendingPage from "pages/ExternalSendingPage/ExternalSendingPage";
import InternalIncomingPage from "pages/InternalIncomingPage/InternalIncomingPage";
import InternalSendingPage from "pages/InternalSendingPage/InternalSendingPage";
import MyCommandmentsPage from "pages/MyCommandmentsPage/MyCommandmentsPage";
import CommandmentsPage from "pages/CommandmentsPage/CommandmentsPage";
import ArchievePage from "pages/ArchievePage/ArchievePage";
import ArchieveDetailPage from "pages/ArchieveDetailPage/ArchieveDetailPage";
import DocumentArchiveClosedIncomingPage from "pages/DocumentArchiveClosedIncomingPage/DocumentArchiveClosedIncomingPage";
import DocumentArchiveClosedIncomingDetailPage from "pages/DocumentArchiveClosedIncomingDetailPage/DocumentArchiveClosedIncomingDetailPage";
import DocumentArchiveClosedSendingDetailPage from "pages/DocumentArchiveClosedSendingDetailPage/DocumentArchiveClosedSendingDetailPage";
import DocumentArchiveClosedSendingPage from "pages/DocumentArchiveClosedSendingPage/DocumentArchiveClosedSendingPage";
import DocumentArchiveSendingExternalPage from "pages/DocumentArchiveSendingExternalPage/DocumentArchiveSendingExternalPage";
import DocumentArchiveSendingExternalDetailPage from "pages/DocumentArchiveSendingExternalDetailPage/DocumentArchiveSendingExternalDetailPage";
import SeeDocumentPage from "pages/SeeDocumentPage/SeeDocumentPage";
import ChatPage from "pages/ChatPage/ChatPage";
import AdvancedFilterPage from "pages/AdvancedFilterPage/AdvancedFilterPage";
import ContextSearchPage from "pages/ContextSearchPage/ContextSearchPage";
import MainPage from "pages/MainPage/MainPage";
import AllLettersPage from "pages/AllLettersPage/AllLettersPage";
import BetweenCompanyPage from "pages/BetweenCompanyPage/BetweenCompanyPage";

export const UserRoutes = () => {
	return (
		<Routes>
			<Route path={routeConstants.root.route} element={<MainPage />} />
			<Route
				path={routeConstants.externalIncoming.route}
				element={<ExternalIncomingPage />}
			/>
			<Route
				path={routeConstants.externalSending.route}
				element={<ExternalSendingPage />}
			/>
			<Route
				path={routeConstants.internalIncoming.route}
				element={<InternalIncomingPage />}
			/>
			<Route
				path={routeConstants.internalSending.route}
				element={<InternalSendingPage />}
			/>
			<Route
				path={routeConstants.myCommandments.route}
				element={<MyCommandmentsPage />}
			/>
			<Route
				path={routeConstants.commandments.route}
				element={<CommandmentsPage />}
			/>
			<Route path={routeConstants.archieve.route} element={<ArchievePage />} />
			<Route
				path={`${routeConstants.archieve.route}/:id`}
				element={<ArchieveDetailPage />}
			/>

			<Route
				path={routeConstants.documentArchiveClosedIncoming.route}
				element={<DocumentArchiveClosedIncomingPage />}
			/>

			<Route
				path={`${routeConstants.documentArchiveClosedIncoming.route}/:id`}
				element={<DocumentArchiveClosedIncomingDetailPage />}
			/>

			<Route
				path={routeConstants.documentArchiveClosedSending.route}
				element={<DocumentArchiveClosedSendingPage />}
			/>

			<Route
				path={`${routeConstants.documentArchiveClosedSending.route}/:id`}
				element={<DocumentArchiveClosedSendingDetailPage />}
			/>
			<Route
				path={routeConstants.documentArchiveSendingExternal.route}
				element={<DocumentArchiveSendingExternalPage />}
			/>

			<Route
				path={`${routeConstants.documentArchiveSendingExternal.route}/:id`}
				element={<DocumentArchiveSendingExternalDetailPage />}
			/>

			<Route
				path={`${routeConstants.seeDocument.route}`}
				element={<SeeDocumentPage />}
			/>
			<Route path={`${routeConstants.chat.route}`} element={<ChatPage />} />
			<Route
				path={`${routeConstants.advancedFilter.route}`}
				element={<AdvancedFilterPage />}
			/>
			<Route
				path={`${routeConstants.contextSearch.route}`}
				element={<ContextSearchPage />}
			/>
			<Route
				path={`${routeConstants.allLetters.route}`}
				element={<AllLettersPage />}
			/>
			<Route
				path={`${routeConstants.betweenCompany.route}`}
				element={<BetweenCompanyPage />}
			/>

			<Route path="*" element={<Navigate to={routeConstants.root.route} />} />
		</Routes>
	);
};
